$ = require('jquery')
multislider = require('./multislider')
matchHeight = require('./matchHeight')

module.exports =
	init: (payload) ->
		{$target} = payload

		$body = $('body')
		$target = $('.filter-target')

		# odstranění ceny před odesláním aby nebyla v URL
		$(document)
			# prevend detail na odkazy uvnitř labelů - skrz indexaic
			.on('click', '.f-filter__link', (e) ->
				e.preventDefault()

				$input = $(this).closest('label').find('input')
				actualValue = $input.prop('checked')

				if actualValue
					$input.prop('checked', false).trigger('change')
				else
					$input.prop('checked', true).trigger('change')
			)
			# ovevírání celého výpisu
			.on('click', '.f-filter__other__tool', (e) ->
				e.preventDefault()

				$(this).closest('.f-filter__other').toggleClass('is-open')
			)
			# responsive filter
			.on('click', '.col-side-fixed__btn a', (e) ->
				e.preventDefault()

				$('.col-side-fixed').toggleClass('is-active')
			)
			.on('click', (event) ->
				if not $(event.target).closest('.col-side-fixed').length and not $(event.target).closest('.col-side-fixed__btn a').length
					$('.col-side-fixed.is-active').removeClass('is-active')
			)
			# trigger paging a tags
			.on('click', '.paging a, .b-tags a', (e) ->
				e.preventDefault()

				data = this.search.slice(1)
				paging = false
				scrolltop = false
				blog = false

				if $(@).closest('.paging__side').length
					paging = true
				if $(@).closest('.paging--blog').length
					blog = $(this).attr('href')

				pushState(data, paging, blog)
			)
			# trigger fixed button
			.on('click', '.f-filter__btn--fixed .btn', (e) ->
				$('.f-filter').submit()
			)
			.on('submit', '.f-filter', (e) ->
				e.preventDefault()

				$inp = $('.f-filter').find('input')
				removeMultislider = true

				$inp.filter('.from').each(->
					if $(this).val()*1 != $(this).closest('.multislider').data('min')*1 && removeMultislider
						removeMultislider = false
				)
				$inp.filter('.to').each(->
					if $(this).val()*1 != $(this).closest('.multislider').data('max')*1 && removeMultislider
						removeMultislider = false
				)
				if removeMultislider
					$inp.filter('.from, .to').attr('name', (i, old) ->

						setTimeout(=>
							$(this).attr('name', old)
						, 10)
						return ''
					)

				data = $('.f-filter').serialize()
				pushState(data, false, false)

				# hide responsive col
				# $('.col-side-fixed').removeClass('is-active')
			)


			# reset
			# .on('click', 'button.reset', (e) ->
			# 	e.preventDefault()

			# 	$inp = $('.f-filter').find('input')
			# 	$inp.attr('checked', false)
			# 	$('.f-filter').find('.multislider').each(->
			# 		$multislider = $(this)
			# 		$multislider.data('slider').noUiSlider.set([$multislider.data('min'), $multislider.data('max')])
			# 	)
			# 	setTimeout(->
			# 		$('body').removeClass('filter-show')
			# 		$('.f-filter').submit()
			# 	100)
			# )

			# input change trigger
			# .on('change', 'input', (e) ->
			# 	$('.f-filter').submit()
			# )

		$(window).on('popstate', (event) ->
			state = event.originalEvent.state
			if state? and state.isFilter
				ajaxFilter(event.originalEvent.state.data)
		)


		pushState = (data, paging, blog) ->
			url = $('.f-filter').attr('action') || window.location.pathname
			# if blog.length
			# 	url = blog
			history.pushState({
				data,
				isFilter: true
			}, "", url + '?' + data)

			if paging
				$('body, html').animate(
					scrollTop: $target.offset().top
				, 250)

			ajaxFilter(data, paging, blog, url)

		ajaxFilter = (data, paging, blog, url) ->
			$.ajax(
				url: url
				data: data + '&ajax=true'
				beforeSend: (e, i) ->
					$body.addClass('show-loader')
			)
			.done((payload) ->
				if payload.form
					$('.f-filter').html(payload.form)
				$target.wrapInner('<div class="before-load"/>')
				$target.append('<div class="after-load" style="width: 100%;"/>')
				$target.find('.after-load').html(payload.content)
				$body.removeClass('show-loader')

				if payload.form
					multislider.init({$target:$('.f-filter')})

				matchHeight.init({$target:$target})

				loadHTML = $target.find('.after-load').html()
				$target.html(loadHTML)

				if paging && !blog.length
					$('body').animate(
						scrollTop: $('.b-annot').offset().top - 40
					, .5)
			)

		return



// WEBPACK FOOTER //
// ./src/js/components/filter.coffee